import {styled} from "@mui/material";
import {ReactNode, useState} from "react";
import MuiAccordion, {AccordionProps} from "@mui/material/Accordion";
import MuiAccordionSummary, {AccordionSummaryProps} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";

const StyledAccordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
    "&:before": {
        display: "none",
    },
    marginBottom: "12px",
    borderRadius: "8px 8px 0px 0px",
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{fontSize: "0.9rem"}}/>} {...props} />
))(({theme}) => ({
    backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "#ffffff",
    flexDirection: "row",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-content": {
        marginLeft: theme.spacing(1),
    },
    padding: "4px 24px",
    borderRadius: "20px",
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    padding: 0,
    borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

interface Props {
    title?: JSX.Element | string;
    children?: ReactNode;
    expanded: boolean;
}

export default function Accordion(props: Props) {
    const [expanded, setExpanded] = useState(props.expanded);

    return (
        <StyledAccordion expanded={expanded} onChange={() => setExpanded((expanded) => !expanded)}>
            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                {props.title}
            </AccordionSummary>
            <AccordionDetails>{props.children}</AccordionDetails>
        </StyledAccordion>
    );
}
